// removed by extract-text-webpack-plugin
module.exports = {"overlay":"style__overlay___2KQxA","overlayModal":"style__overlayModal___22_X2","overlayModalInner":"style__overlayModalInner___3dGzC","overlayCloseButton":"style__overlayCloseButton___Ri9h7","overlayModalTitle":"style__overlayModalTitle___wew3_","overlayModalText":"style__overlayModalText___1aMFL","overlayModalTextBold":"style__overlayModalTextBold___1ZPn_","overlayModalButtons":"style__overlayModalButtons___3DZt5","overlayModalButtonsItem":"style__overlayModalButtonsItem___33a7k","overlayModalButtonsItemButton":"style__overlayModalButtonsItemButton___2Xfng","buttonActive":"style__buttonActive___1XTqT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modal-imageamount/style.css
// module id = 811
// module chunks = 0